import React from 'react';
import { PROCESS_STEPS } from '../data/constants';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const Process: React.FC = () => {
  const { setRef, isVisible } = useIntersectionObserver();
  return (
    <section id="process" ref={setRef('process')} className="process-section">
      <div className="process-inner">
        <div className="process-header-row">
          <div className={`sf ${isVisible('process') ? 'vis' : ''}`}>
            <div className="eyebrow-dark">Better process</div>
            <h2 className="section-h2">The Process of Working with Us</h2>
          </div>
          <div className={`sf ${isVisible('process') ? 'vis' : ''}`} style={{ transitionDelay: '0.12s' }}>
            <p style={{ fontSize: 16, color: '#718096', lineHeight: 1.8 }}>
              From initial enquiry to on-site delivery, our streamlined process ensures your GRP project is delivered on time, on specification, and to the highest quality standards.
            </p>
          </div>
        </div>

        <div className="process-grid">
          {PROCESS_STEPS.map((step, i) => (
            <div key={step.num} className={`process-step sf ${isVisible('process') ? 'vis' : ''}`} style={{ transitionDelay: `${i * 0.1}s` }}>
              <div className="process-num-ring">
                <span className="process-num font-display">{step.num}</span>
              </div>
              <h4 className="process-title">{step.title}</h4>
              <p className="process-desc">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Process;
